import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { toast } from "react-hot-toast";
import { API } from "../../../constants/api";
import { useUser } from "../../../context/user-context";
import useAuthAxios from "../../../utils/baseAxios";
import { errorMessage } from "../../../utils/errorMessage";
import ClipLoader from "react-spinners/ClipLoader";

const BankDetail = ({ setOpenBank, bankId }: any) => {
  const { userDetails, refetch } = useUser();
  const banks = userDetails?.user?.banks;
  const selectedBank = banks?.find((bank: any) => bank._id === bankId);
  const axiosInstance = useAuthAxios();

  //   console.log(selectedBank);
  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });
  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);

  const deleteBank = async () => {
    const response = await axiosInstance.delete(API.deleteBank(bankId), {});
    return response.data;
  };
  const completeDeleteBank = useMutation({
    mutationFn: deleteBank,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();

      setOpenBank(false);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });

  const makeDefault = async () => {
    const response = await axiosInstance.put(API.makeDefaultBank(bankId), {});
    return response.data;
  };

  const completeMakeDefault = useMutation({
    mutationFn: makeDefault,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setTimeout(() => {
        setOpenBank(false);
      }, 1500);
      //   handleOptionsClick(loadingIndex ? loadingIndex : 100);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
    },
  });
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenBank(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            Bank Details
          </h4>
        </div>
        <div className="mt-8 w-full">
          <div
            onClick={() => {}}
            className={
              selectedBank?.isDefault
                ? "  px-2 py-10 bg-defaultBankBg cursor-pointer flex flex-col justify-center bg-cover rounded-lg items-center"
                : "  px-2 py-10 bg-noDefaultBankBg cursor-pointer flex flex-col justify-center bg-cover rounded-lg items-center"
            }
          >
            <div className="flex justify-between gap-3 items-center">
              <h4 className="font-semibold text-[#0B75C2] text-[16px]">
                {selectedBank?.accountName}
              </h4>
              {/* <input
                  type="radio"
                  name=""
                  className="w-[20px] h-[20px]"
                  id=""
                /> */}
            </div>
            <h5 className="text-[#010D16] text-[15px] font-bold pt-2">
              {selectedBank?.accountNumber}
            </h5>
            {(() => {
              const matchedBank =
                allBanks?.data.find(
                  (allBank: any) => allBank.bankCode === selectedBank?.bankCode
                ) ||
                allOldBanks?.data.find(
                  (newBank: any) => newBank.code === selectedBank?.bankCode
                );

              return matchedBank ? (
                <h5 className="text-[#010D16] font-medium text-[13px] pt-2">
                  {matchedBank.bankName || matchedBank.name || "Unknown Bank"}
                </h5>
              ) : null;
            })()}
          </div>
          <div className="mt-32">
            {!selectedBank?.isDefault && (
              <button
                onClick={() => {
                  completeMakeDefault.mutate();
                }}
                className=" bg-secondary_button text-white font-medium text-[14px] h-[48px] rounded-xl w-full"
              >
                {completeMakeDefault.isPending ? (
                  <ClipLoader color="#FFFFFF" size={30} />
                ) : (
                  "Make Default bank"
                )}
              </button>
            )}
            <button
              onClick={() => {
                completeDeleteBank.mutate();
              }}
              className="mt-4 text-[#D92B2B]  font-medium text-[14px]  rounded-xl w-full"
            >
              {completeDeleteBank.isPending ? (
                <ClipLoader color="#FFFFFF" size={30} />
              ) : (
                "Delete Bank"
              )}
            </button>
          </div>
          <h4 className=" text-center mt-6 text-gray-500 dark:text-gray-400 text-[13px] font-medium">
            Cards are essential in swift buying of crypto and funding your cash
            wallet
          </h4>
        </div>
      </div>
    </div>
  );
};

export default BankDetail;
